import type { SearchControlsSubmitParams } from '@shared/hotels-search-controls/SearchBar/SearchBar';
import type { FormatDate } from '@shared/types/i18n/localisation-service';

import { getDayviewUrl } from '@shared/utils-frontend/url/url';

export const onSearchControlsSubmit = (
  { destination, ...rest }: SearchControlsSubmitParams,
  formatDate: FormatDate,
) =>
  window.open(getDayviewUrl({ destination, stay: rest }, formatDate), '_blank');
